import React from "react";

import { ImpactHeatmap as ImpactHeatmapComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

const defaultEmptyContract = {
    points: [] as Array<{
        t: string;
        x: number;
        y: number;
        shotNumber: number;
        radialError?: number;
        series?: number;
        sector?: number;
    }>,
    meta: {
        xDomain: [-1, 1] as [number, number],
        yDomain: [-1, 1] as [number, number],
        unit: "normalized",
        center: { x: 0, y: 0 },
    },
};

const ImpactHeatmap = () => {
    const { impactHeatmapData, isFetchingDashboardData, isErrorDashboardData } =
        useSessionDetailsContext();

    const data = impactHeatmapData?.data ?? defaultEmptyContract;
    const title = impactHeatmapData?.title;
    const legendType = impactHeatmapData?.legendType;
    const showAxisLabels = impactHeatmapData?.showAxisLabels;

    if (isFetchingDashboardData) {
        return <ContentLoader height="18rem" />;
    }

    if (isErrorDashboardData && !impactHeatmapData) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="18rem"
                />
            </ComponentWrapper>
        );
    }

    return (
        <ImpactHeatmapComponent
            data={data}
            title={title}
            legendType={legendType}
            minHeight="18rem"
            {...(showAxisLabels !== undefined && { showAxisLabels })}
        />
    );
};

export default ImpactHeatmap;
